import cn from 'classnames';
import { HTMLAttributes } from 'react';
import styles from './topbar.module.scss';


export function Topbar ({ className, ...props }: HTMLAttributes<HTMLElement>) {
    return (
        <header
            className={ cn(styles.root, className) }
            { ...props }
        />
    );
}
